module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-middleware/node_modules/core-js/library/modules/$.property-desc.js
// module id = 258
// module chunks = 1 2 3